import { memo } from "react";
import { VerificationAppDocumentType } from "../../models";
import { StepTypeEditorProps } from "./types";
import { BeneficialOwnershipStepTypeSpecificProps } from "./stepTypeEditors/BeneficialOwnershipStepTypeSpecificProps";
import { DefaultStepTypeSpecificProps } from "./stepTypeEditors/DefaultStepTypeSpecificProps";
import { EntityRepresentativesStepTypeSpecificProps } from "./stepTypeEditors/EntityRepresentativesStepTypeSpecificProps";
import { IdentificationStepTypeSpecificProps } from "./stepTypeEditors/IdentificationStepTypeSpecificProps";

const STEP_TYPE_EDITOR_REGISTRY: Partial<
  Record<VerificationAppDocumentType, (props: StepTypeEditorProps) => JSX.Element | null>
> = {
  [VerificationAppDocumentType.UserInformation]: DefaultStepTypeSpecificProps,
  [VerificationAppDocumentType.Residence]: DefaultStepTypeSpecificProps,
  [VerificationAppDocumentType.Occupation]: DefaultStepTypeSpecificProps,
  [VerificationAppDocumentType.FinancialInformation]: DefaultStepTypeSpecificProps,
  [VerificationAppDocumentType.BeneficialOwnership]: BeneficialOwnershipStepTypeSpecificProps,
  [VerificationAppDocumentType.EntityInformation]: DefaultStepTypeSpecificProps,
  [VerificationAppDocumentType.DocumentSigning]: DefaultStepTypeSpecificProps,
  [VerificationAppDocumentType.Custom]: DefaultStepTypeSpecificProps,
  [VerificationAppDocumentType.Identification]: IdentificationStepTypeSpecificProps,
  [VerificationAppDocumentType.EntityRepresentatives]:
    EntityRepresentativesStepTypeSpecificProps,
};

export const StepTypeSpecificProps = memo((props: StepTypeEditorProps) => {
  const Component = STEP_TYPE_EDITOR_REGISTRY[props.step.type] ?? DefaultStepTypeSpecificProps;
  return <Component {...props} />;
});
